import { AbstractionBase } from '@awayjs/core';
/**
 * @class away.pool.MaterialPoolBase
 */
var _Render_ElementsBase = /** @class */ (function () {
    /**
     * //TODO
     *
     * @param materialClassGL
     */
    function _Render_ElementsBase(stage, materialClassPool, renderGroup) {
        this.id = AbstractionBase.ID_COUNT++;
        this.stage = stage;
        this._materialClassPool = materialClassPool;
        this.renderGroup = renderGroup;
    }
    _Render_ElementsBase.prototype.requestAbstraction = function (asset) {
        return this._materialClassPool[asset.assetType];
    };
    _Render_ElementsBase.prototype._includeDependencies = function (shader) {
    };
    _Render_ElementsBase.prototype._getVertexCode = function (shader, registerCache, sharedRegisters) {
        return '';
    };
    _Render_ElementsBase.prototype._getFragmentCode = function (shader, registerCache, sharedRegisters) {
        return '';
    };
    return _Render_ElementsBase;
}());
export { _Render_ElementsBase };
